import React from 'react';
import { Button } from '@naf-simba/elements-buttons';
import { Text, TextVariant } from '@naf/text';
import { CountdownBlockType } from '@appTypes/countdownBlockType';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import Timer from './Timer';
import * as S from './CountdownBlock.styles';
import { useCountdownCta } from './useCountdownCta';

type CountdownBlockProps = { block: CountdownBlockType };

const CountdownBlock = ({ block }: CountdownBlockProps) => {
  const { backgroundImage: bgImg, logoImage: logo, countdownTo, tagline, linkBlock, ctaButton } = block;
  const { getProcessedImage } = useCloudinary();
  const ctaButtonProps = useCountdownCta({ linkBlock, ctaButton });

  const backgroundImage =
    getProcessedImage(bgImg?.publicId || bgImg?.public_id, {
      width: 900,
      focusMethod: bgImg?.focus,
    })?.toURL() || bgImg?.srcSet?.jpgLarge;

  const logoImage =
    getProcessedImage(logo?.publicId || logo?.public_id, {
      height: 32,
      focusMethod: logo?.focus,
    })?.toURL() || logo?.srcSet?.jpgLarge;

  return (
    <S.CardBackground $backgroundSrc={backgroundImage}>
      <S.TextContainer>
        {logo && <S.LogoImage alt={logo?.altText || 'Logo'} src={logoImage} />}
        <Text variant={TextVariant.Header1} tag="h2">
          {tagline}
        </Text>
        <Timer targetTime={countdownTo} />
        {ctaButtonProps && (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Button {...ctaButtonProps.buttonProps}>{ctaButtonProps.text}</Button>
        )}
      </S.TextContainer>
    </S.CardBackground>
  );
};

export { CountdownBlock };
